import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { FilterBarContainer } from '../FilterBarContainer';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { SlidersHorizontal } from 'lucide-react';

type FilterAccordionProps = {
  children: React.ReactNode;
};

// Collapsible "Filters" bar shared by all dashboard pages; collapsed by default
export const FilterAccordion: React.FC<FilterAccordionProps> = ({
  children,
}) => {
  return (
    <FilterBarContainer alignItems="flex-start" flexDir="column" py={0}>
      <Accordion allowToggle w="100%" defaultIndex={[]}>
        <AccordionItem border="none">
          <AccordionButton py={4} px={0} _hover={{ bg: 'transparent' }}>
            <Flex align="center" flex="1">
              <ChakraIcon as={SlidersHorizontal} boxSize={4} mr={2} />
              <Text
                fontFamily="marketingPage"
                fontWeight="medium"
                fontSize="sm"
                color="text.darkGray">
                Filters
              </Text>
            </Flex>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel px={0} pb={4}>
            {children}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </FilterBarContainer>
  );
};
